import { render, staticRenderFns } from "./allRegList.vue?vue&type=template&id=0c0cd90d&scoped=true&"
import script from "./allRegList.vue?vue&type=script&lang=js&"
export * from "./allRegList.vue?vue&type=script&lang=js&"
import style0 from "./allRegList.vue?vue&type=style&index=0&id=0c0cd90d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0cd90d",
  null
  
)

export default component.exports